import { useContext, useState } from 'react';

import { DeviceContext } from '@/components/DeviceProvider/DeviceProvider';
import { MEDIUM_BREAKPOINT } from '@/components/modular-grid/constants';
import { mapNavItems } from '@/components/Navigation/utils';
import { useWindowSize } from '@/hooks/useWindowSize';

import styles from './BottomNavigation.module.scss';
import ItemCommand from './Items/ItemCommand';
import ItemDefault from './Items/ItemDefault';
import ItemGame from './Items/ItemGame';
import ItemLink from './Items/ItemLink';
import { BottomNavigationItem, BottomNavigationProps } from './types';

const BottomNavigation = ({
  items,
  onBottomNavigationItemClick,
  onBottomNavigationGameClick,
  onBottomNavigationCommandClick,
  activeCommandItem,
  currentPagePath,
  pageTitle,
}: BottomNavigationProps) => {
  const { width, height } = useWindowSize();
  const { deviceType, deviceOs } = useContext(DeviceContext);

  const [activeCommandTitle, setActiveCommandTitle] = useState<string>('');

  const activeCommand = activeCommandItem ? activeCommandTitle : '';
  const navItems = mapNavItems(items, [currentPagePath], {
    activeCommand,
    deviceOs,
  });

  if (height < 225 || width > MEDIUM_BREAKPOINT.max) return null;

  const renderBottomNavigationItems = (items: BottomNavigationItem[]) =>
    items.map((item, index) => {
      if (item.url) return <ItemLink key={index} item={item} index={index} />;
      if (item.game)
        return (
          <ItemGame
            key={index}
            item={item}
            index={index}
            deviceType={deviceType}
            deviceOs={deviceOs}
            pageTitle={pageTitle}
            onGameClick={onBottomNavigationGameClick}
          />
        );
      if (item.command)
        return (
          <ItemCommand
            key={index}
            item={item}
            index={index}
            onCommandItemClick={onBottomNavigationCommandClick}
            setActiveCommandTitle={setActiveCommandTitle}
          />
        );
      return (
        <ItemDefault
          key={index}
          item={item}
          index={index}
          onDefaultItemClick={onBottomNavigationItemClick}
        />
      );
    });

  return (
    <div className={styles.wrapper}>
      <div
        className={styles.slotWrapper}
        data-testid="bottom-navigation-slot-wrapper"
      >
        {renderBottomNavigationItems(navItems)}
      </div>
    </div>
  );
};

export default BottomNavigation;
